var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83873 15.3H10.4348C14.4872 15.3 17.7165 12.085 17.8432 8.11354V8.0505C17.7798 4.01596 14.4872 0.737903 10.4348 0.800943H7.52214C3.65967 0.927022 0.620344 4.20508 0.746982 8.11354C0.746982 12.022 3.91294 15.237 7.83873 15.3ZM2.01337 8.05047C2.01337 4.77241 4.73609 2.06171 8.02869 2.06171C11.3213 2.06171 14.044 4.77241 14.044 8.05047C14.044 11.3285 11.3213 14.0392 8.02869 14.0392C4.73609 14.0392 2.01337 11.3285 2.01337 8.05047ZM8.97754 12.0834V4.07739C11.1937 4.64475 12.5867 6.85114 12.0169 9.05752C11.6369 10.5705 10.4972 11.7052 8.97754 12.0834ZM4.10354 7.04025C3.53367 9.24664 4.86337 11.5161 7.07955 12.0834V4.07739C5.6232 4.45563 4.48346 5.59034 4.10354 7.04025Z",
    fill: "#0079BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/dinersClub.65a9524651193fccb4011780c20dff06.svg";
export { ForwardRef as ReactComponent };